import { CarrierSalesProfile } from "@mcleod/powerbroker/src/crm/CarrierSalesProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: CarrierSalesProfile;
    panel1: Panel;
    panel2: Panel;
    sourceCarrierSalesProfile: DataSource;
}
